import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  Inject,
  NgZone,
  Output,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  EventEmitter,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as _ from 'lodash';




import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, UntypedFormControl } from '@angular/forms';

import { SearchResultsComponent } from 'shared/search/search-results/search-results.component';
import { CellWidthDirective } from '../cell-width.directive';

import { MyFitmentsSearchService } from '../my-fitments-search.service';
import { BrandService } from 'shared/brand/brand.service';
import { FitmentsService } from 'shared/fitments/fitments.service';
import { AppModalService } from 'shared/modal/modal.service';

import { YEAR_START_TYPE, YEAR_END_TYPE } from 'shared/search/advanced-search/filter-types';
import { sideDrawerMenuWidth, searchResultsOffset } from '../../../../variables';
import { FITMENT_DUPLICATE_MODAL_NAME } from 'shared/modal/modal-names';
import { groupedAttributes } from '../grouped-attributes';
import { ResearchModel } from './research.model';
import { editableInCellColumns } from './editable-in-cell-columns';
import { nestedTableEditableColumns } from '../cell-edit-form/editable-columns';
import { Option } from 'shared/form/select/option.interface';
import { createOption } from 'shared/form/select/option-helpers';
import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { LIST_FILTER_TYPE } from 'shared/search/active-filters/active-filter-types';
import {debounceTime, takeWhile, first} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Component({
  moduleId: module.id,
  selector: 'fitments-search-results',
  templateUrl: 'fitments-search-results.component.html',
  styleUrls: ['fitments-search-results.component.scss'],
})
export class FitmentsSearchResultsComponent extends SearchResultsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedProduct: any;
  @Input() attributesList: Array<any>;
  @Input() showIconForEmptyVal: boolean = false;
  @Input() tooltipTextsMap: any;
  @Input() isResearchResults: boolean = false;
  @Input() disableResearch: boolean = false;
  @Input() disableEdit: boolean = false;
  @Input() stickCheckboxes: boolean = false;
  @Input() searchResultsWrapWidth: number = 0;
  @Input() searchResultsScrollLeft: number = 0;
  @Input() searchResultsOffset: number = searchResultsOffset;
  @Input() filters: Array<ActiveFilterModel>;
  @Input() comingSoonColumns: Array<string>;
  @Input() isVersion2: boolean = false;
  @Input() isIndexPage: boolean = false;
  @Input() striped: boolean = false; // table lines are white & gray

  @Output() researchSaved = new EventEmitter<any>();
  @Output() infoIconClick = new EventEmitter<any>();
  @Output() highlightedValueClick = new EventEmitter<any>();
  @Output() fitmentPanelOpen = new EventEmitter<any>();
  @Output() baseVehicleResearch = new EventEmitter<any>();
  @Output() containerChanged = new EventEmitter<any>();
  @Output() editedChangesSaved = new EventEmitter<any>();
  @Output() revisionIdChanged = new EventEmitter<string|number>();

  @HostBinding('style.width')
  public get componentWidth(): string {
    return this.containerWidth ? `${this.containerWidth + this.searchResultsOffset}px` : '100%';
  }

  researchRows: Array<any> = [];
  activeResearchRow: any; // parent row on which was click
  activeRowIndex: number;
  activeResearchColumn: any;
  showSpinner: any = {};
  selectedResearchRows: Array<any> = [];
  researchColumns: Array<string> = [];
  checkedCopyInfo: boolean = true;
  showCopyInfoNote: boolean = false;
  statusColorMap: any = {
    '0': 'green', // valid
    '1': 'red', // invalid
    '2': 'yellow', // duplicate
  };
  containerWidth: number;
  visibleWidth: number;
  isActive: boolean = true;

  researchModel: ResearchModel = new ResearchModel();
  // editing cell data
  activeEditRow: any;
  activeEditColumn: any;
  cellControlsForm: UntypedFormGroup; // form for the controls in the cells
  lookup: any = {
    position: [],
    qty: [],
    positionsByFitmentId: {
    }
  };
  selectPlaceholderOptions: Array<any> = ['']; // options that will be replaced on placeholder

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get productId(): any {
    return _.get(this.selectedProduct, '_id');
  }

  get partTerminology(): string {
    return _.get(this.selectedProduct, 'partTerminology.name');
  }

  get spinnerWidth(): string {
    return `${this.visibleWidth + this.searchResultsOffset + 20}px`;
  }

  get brandId(): any {
    return this.brandService.getBrand();
  }

  get researchColumnName(): string {
    return _.get(this.activeResearchColumn, 'columnName', '');
  }

  get activeListFilters(): Array<any> {
    return _.filter(this.filters, ['type', LIST_FILTER_TYPE]);
  }

  constructor(
    protected sanitizer: DomSanitizer,
    private searchService: MyFitmentsSearchService,
    private brandService: BrandService,
    private fitmentsService: FitmentsService,
    private ref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any,
    private ngZone: NgZone,
    private appModalService: AppModalService,
    private fb: UntypedFormBuilder,
  ) {
    super(sanitizer, null);
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.rows && changes.rows.currentValue) ||
        changes.columns && changes.columns.currentValue) {
      if (!this.isResearchResults && !changes.columns) {
        // Don't reset columns maxWIdth in the research-results and when columns changes
        _.map(this.columns, (item: any) => item.maxWidth = null);
      }
      this.cancelAllResearchData();
      this.clearEdit();
      this.cellControlsForm = null;
      _.defer(() => {
        this.setContainerWidth();
        this.containerChanged.emit();
      });
    }
    if (changes.disableResearch && changes.disableResearch.currentValue === true) {
      this.cancelAllResearchData();
    }
    if (changes.disableEdit && changes.disableEdit.currentValue === true) {
      this.clearEdit();
      this.cellControlsForm = null;
    } else {
      this.createCellControlsForm();
    }
  }

  ngOnInit() {
    if (!this.isResearchResults) {
      // Don't subscribe window listener in the research results
      this.ngZone.runOutsideAngular(() => {
        this.subscribeWindowResize();
      });
      // get positions lookup
      if (this.selectedProduct) {
        this.fitmentsService.getPositions(
          this.brandId,
          this.selectedProduct._id,
        )
        .pipe(takeWhile(() => this.isActive))
        .subscribe((data: any) => {
          this.lookup.position = [createOption('', '-'), ...data];
          this.ref.markForCheck();
        });
        // quantity lookup
        this.lookup.qty = _.map(_.range(1, 101), (num: number) => {
          return createOption(num);
        });
      }
      this.ref.markForCheck();
    }
  }

  ngOnDestroy() {
    this.cancelAllResearchData();
    this.clearEdit();
    this.cellControlsForm = null;
    this.isActive = false;
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onResearchClick($event: any, index: number) {
    // if user clicks on specific fields like mfr label, notes
    // then we should display nested table form, that contains form for edit these fields
    if (this.isEditAllowed($event.row, $event.column, index)) {
      this.cancelAllResearchData();
      if (_.get(this.activeEditColumn, 'columnName') !== $event.column.columnName) {
        this.showNestedTableEditForm($event.row, $event.column, index);
      } else {
        this.clearEdit();
      }
      return;
    }
    // isResearchAllowed may have side effects:
    // if user clicks on the same column twice it should be closed,
    // if base vehicle is invalid then open add fitment modal
    if (this.isResearchAllowed($event.row, $event.column, index)) {
      this.clearEdit();
      this.clearResearch();
      this.runResearch($event.row, $event.column, index);
    }
  }

  onResearchCheckboxChanged(item: any) {
    if (item.selected) {
      this.selectedResearchRows.push(item);
    } else {
      _.pullAllBy(this.selectedResearchRows, [item], this.searchService.idField);
    }
    if (this.selectedResearchRows.length === 1) { this.checkedCopyInfo = true; }
    this.showCopyInfoNote = this.selectedResearchRows.length > 1;
  }

  onCancelResearchClick(index: number) {
    this.cancelAllResearchData();
  }

  onSaveResearchClick(index: number) {
    const assignedItem = _.find(this.researchRows, ['assigned', true]);
    // if assigned item exists and was unchecked then remove row
    if (assignedItem && !assignedItem.selected && !this.selectedResearchRows.length) {
      this.removeAttribute(index);
      return;
    }
    if (!this.selectedResearchRows.length) { return; }
    this.showSpinner[index] = true;
    let request: any;
    if (this.activeResearchRow.status === 1) {
      // for invlid fitment use different api call SPD2-2815
      request = this.fitmentsService.replaceAppMultipleColumns(
        this.brandId,
        this.productId,
        this.getMultipleColumnsReplaceData(),
      );
    } else {
      request = this.fitmentsService.replaceApp(
        this.brandId,
        this.productId,
        this.getReplaceAppData(),
      );
    }
    request
    .pipe(takeWhile(() => this.isActive))
    .subscribe((data: any) => {
      this.researchSaved.emit();
      this.emitRevisionId(_.get(data, 'item_detail_revision_id'));
    });
  }

  onCheckboxChange(event: any, column: any) {
    if (this.activeResearchRow) { return; }
    super.onCheckboxChange(event, column);
  }

  onCheckboxClick(event: any, row: any) {
    if (this.activeResearchRow) { return; }
    super.onCheckboxClick(event, row);
  }

  onCopyInfoChange(event: any) {
    this.checkedCopyInfo = event.target.checked;
  }

  onResearchPaginationBtnClick(direction: number) {
    this.researchModel.currentPage += direction;
    this.runResearch(this.activeResearchRow, this.activeResearchColumn, this.activeRowIndex);
  }

  // editing row cell

  onCancelEditClick() {
    this.clearEdit();
  }

  /*
    * Callback after saving data in the nested table
    * $event: {appId: string|number}
   */
  onSaveFinished($event: any) {
    // fetch fitments after save
    this.editedChangesSaved.emit();
    this.emitRevisionId(_.get($event, 'item_detail_revision_id'));
  }

  /*
    * Handle cell's select update
    * Gets all required for save data
    * Calls save request
   */
  onCellSelectChange($event: any, row: any, column: any, index: number) {
    this.showSpinner[index] = true;
    // get required data
    const data: any = {
      app_ids: [_.get(row, 'assignment_values.app_id')],
    };
    _.each(nestedTableEditableColumns, (item: any) => {
      if (item.comingSoon) { return; }
      _.set(data, item.fieldMap, _.get(row, item.itemName));
    });
    _.each(editableInCellColumns, (item: any, columnName: string) => {
      let value: string|number;
      if (columnName === column.column_name) {
        value = _.get($event, 'option');
      } else {
        value = _.get(row, item.itemName);
      }
      _.set(data, item.fieldMap, value);
    });
    // call save request
    this.fitmentsService.updateApps(this.brandId, this.productId, data)
    .pipe(takeWhile(() => this.isActive))
    .subscribe((res: any) => {
      this.revisionIdChanged.emit(_.get(res, 'item_detail_revision_id'));
      if (_.get(row, `highlightedColumns.${column.col}`)) {
        // fetch fitments if column was invalid
        this.editedChangesSaved.emit();
        return;
      }
      // do not fetch fitments after save
      // just update row data and row app id that has been changed
      this.showSpinner[index] = false;
      this.updateEditedRowAfterSave(
        _.get(res, 'app_ids[0]'),
        row,
        column,
        _.get($event, 'option'),
        _.get($event, 'title')
      );
    }, () => {
      this.showSpinner[index] = false;
      this.ref.markForCheck();
    });
  }

  onControlFocus(columnName: string, row: any) {
    // get positions by fitment ID for rows with part terminologies (SPD2-5360)
    if (columnName === 'position' && this.isPartTerminologiesExists(row)) {
      this.lookup.position = [];
      this.ref.markForCheck();
      this.fitmentsService.getPositionsByFitmentId(
        row?.assignment_values?.app_id,
      )
      .pipe(takeWhile(() => this.isActive))
      .subscribe((data: any) => {
        this.lookup.positionsByFitmentId[row?.assignment_values?.app_id] = [createOption('', '-'), ...data];
        this.ref.markForCheck();
      });
    }
  }

  /*******************************************
  * COMPONENT PUBLIC
  *******************************************/

  showCopyModal() {
    this.appModalService.showModal(
      FITMENT_DUPLICATE_MODAL_NAME,
      {
        mfrLabel: _.get(this.activeResearchRow, 'assignment_values.mfr_label'),
        partTerminology: this.partTerminology,
        qty: _.get(this.activeResearchRow, 'assignment_values.qty'),
        positionId: _.get(this.activeResearchRow, 'assignment_values.position_id'),
        notes: _.get(this.activeResearchRow, 'assignment_values.notes'),
        productId: this.productId,
      }
    );
    this.subscribeDuplicateModal();
  }

  getCopyTooltipText(): string {
    return this.tooltipTemplate(
      'Copy optional info:',
      'Manufacturer label, Quantity & Position, Notes'
    );
  }

  getDuplicateTooltipText(): string {
    return this.tooltipTemplate(
      'Duplicate Fitment:',
      'This vehicle is already defined'
    );
  }

  getInvalidCombinationTooltipText(): string {
    return this.tooltipTemplate(
      'Invalid Combination:',
      'This combination of vehicle attributes is not valid'
    );
  }

  getDroppedIdsTooltipText(): string {
    return this.tooltipTemplate(
      'Update This Fitment:',
      'Values in red no longer exist. Research and reassign vehicles, or click on vehicle attributes in edit mode'
    );
  }

  getLookup(columnName: string, row: any) {
    if (columnName === 'position' && this.isPartTerminologiesExists(row)) {
      return this.lookup.positionsByFitmentId[row?.assignment_values?.app_id];
    }
    return this.lookup[columnName];
  }

  getPlaceholderOptions(columnName: string, row: any) {
    if (columnName === 'position' && this.isPartTerminologiesExists(row)) {
      return row.position;
    }
    return '';
  }

  isEngineBaseCol(column: any): boolean {
    if (!column) { return false; }
    return _.includes(groupedAttributes.engineBase.attributes, column.column_name);
  }

  getEngineBaseGroupTitle(): string {
    return _.get(groupedAttributes, 'engineBase.groupTitle', '');
  }

  switchTooltip(row: any): string {
    if (!row) { return ''; }
    if (row.has_duplicates === 1) {
      return 'duplicates-tooltip';
    } else if (row.audit_combined_error) {
      return 'audit-combined-error-tooltip';
    } else if (row.highlightedColumns && _.size(row.validation.vcdb)) {
      return 'dropped-ids-tooltip';
    } else {
      return '';
    }
  }

  isClickable(row: any, column: any): boolean {
    if (row.invalidBaseVehicle) {
      // only year/make/model are clickable
      return this.isBaseVehicleColumn(column);
    } else {
      // all columns barring year/make/model are clickable
      return !this.isBaseVehicleColumn(column);
    }
  }

  isPartTerminologiesExists(row: any): boolean {
    return !!row?.part_terminologies?.length;
  }

  /*******************************************
  * COMPONENT PRIVATE
  *******************************************/

  private setData(row: any, column: any, index: number, data: any) {
    this.activeResearchRow = row;
    _.map(this.columns, (item: any) => item.researched = false);
    column.researched = true;
    this.activeResearchColumn = column;
    this.activeRowIndex = index;
    this.researchRows = data.data;
    _.set(this.researchModel, 'currentPage', data.current_page);
    _.set(this.researchModel, 'perPage', data.per_page);
    _.set(this.researchModel, 'lastPage', data.last_page);
    _.set(this.researchModel, 'total', data.total);
    _.each(data.data, (item: any) => {
      const selectedItem = _.find(
        this.selectedResearchRows,
        [this.searchService.idField, item[this.searchService.idField]]
      );
      if (selectedItem) { item.selected = true; }
    });
    _.defer(() => this.setVisibleWidth());
    this.ref.markForCheck();
    if (_.last(this.rows) === row) {
      _.defer(() => window.scrollTo(0, document.body.scrollHeight));
    }
  }

  /*
    * Create data for research request (array of column names, attribute key/value)
    * paying attention to invalid values, grouped columns, errors (such as audit combined error) in the item
  */
  private getResearchQueryStirng(row: any, selectedCol: any) {
    let queryString = '';
    const isEngineBaseResearch = this.isEngineBaseCol(selectedCol);
    _.each(this.columns, (column: any) => {
      if (column.col === 'select-btn' || _.includes(['notes', 'qty', 'position', 'mfr_label'], column.col)) { return; }
      const invalidValue = _.get(row, `highlightedColumns.${column.col}`, null);
      const value = _.get(row, `assignment_values.${column.col}_id`, row[column.col]);

      // SPD2-2816
      // if fitment has invalid combination, then perform request by YMM only
      if (row.audit_combined_error) {
        if (this.isBaseVehicleColumn(column) && !invalidValue) {
          queryString += this.getAttributeQueryString(column, value);
        }
        this.researchColumns.push(column.columnName);
        return;
      }

      // add asssigned column value to the research request
      if (!invalidValue && value && selectedCol.columnName !== column.columnName) {
        // don't add enginebase columns values if it was researched by any engineBase column
        if (!(isEngineBaseResearch && this.isEngineBaseCol(column))) {
          queryString += this.getAttributeQueryString(column, value);
        }
        this.researchColumns.push(column.columnName);
      }
      // add researched column to the request
      if (selectedCol.columnName === column.columnName) {
        this.researchColumns.push(column.columnName);
      }
      if (isEngineBaseResearch && this.isEngineBaseCol(column)) {
        this.researchColumns.push(column.columnName);
      }
      // if fitment is invalid then add invalid column to research
      if (row.status === 1 && invalidValue) {
        this.researchColumns.push(column.columnName);
      }
    });
    this.researchColumns = _.uniq(this.researchColumns);
    queryString += this.searchService.getColumnsQueryString(this.researchColumns);
    queryString += `&itemsPerPage=${this.researchModel.perPage}&page=${this.researchModel.currentPage}`;
    return queryString.substring(1);
  }

  private getAttributeQueryString(column: any, value: any): string {
    const attribute = _.find(this.attributesList, ['column_name', column.columnName]);
    if (!attribute) { return ''; }
    if (attribute.is_range) {
      return `&${attribute.from_field}=${value}&${attribute.to_field}=${value}`;
    } else {
      return `&${attribute.column_name}=${value}`;
    }
  }

  private getReplaceRequestColumnData(columns: Array<any>): any {
    return _.map(this.selectedResearchRows, (item: any) => {
      return _.reduce(columns, (result: any, column: any) => {
        const attribute: any = _.find(this.attributesList, ['column_name', column.columnName]);
        let columnName = _.get(attribute, 'app_doc_map.result_id_field');
        if (!columnName) {
          columnName = item.assignment_values[column.col + '_id'] ? column.col + '_id' : column.col;
        }
        _.set(result, columnName, _.get(item, `assignment_values.${columnName}`));
        _.set(result, 'include_misc', this.checkedCopyInfo);
        const attributeColumnName = _.get(attribute, 'column_name');
        if (result.display_columns) {
          result.display_columns.push(attributeColumnName);
        } else {
          _.set(result, 'display_columns', [attributeColumnName]);
        }
        return result;
      }, {});
    });
  }

  private getMultipleColumnsReplaceData(): any {
    const data: any = {
      'app_id': _.get(this.activeResearchRow, 'assignment_values.app_id'),
    };
    const columns = _.filter(this.columns, (column: any) => {
      // update invalid columns and researched column values
      return !!_.get(this.activeResearchRow, `highlightedColumns.${[column.col]}`) || column.researched;
    });
    _.set(data, 'add_columns', this.getReplaceRequestColumnData(columns));
    return data;
  }

  /*
    * Used for valid fitment with fitmentsService.replaceApp method only
  */
  private getReplaceAppData(): any {
    const column: any = _.find(this.columns, ['researched', true]);
    const attribute: any = _.find(this.attributesList, ['column_name', column.columnName]);
    let columnName = _.get(attribute, 'app_doc_map.result_id_field');
    if (!columnName) {
      columnName = this.selectedResearchRows[0].assignment_values[column.col + '_id'] ? column.col + '_id' : column.col;
    }
    return {
      'app_id': _.get(this.activeResearchRow, 'assignment_values.app_id'),
      'add_column': {
        'column': columnName,
        'display_column': _.get(attribute, 'column_name'),
        'include_misc': this.checkedCopyInfo,
        'values': _.map(this.selectedResearchRows, (item: any) => {
          return _.get(item, `assignment_values.${columnName}`);
        }),
      },
    };
  }

  private removeAttribute(index: number) {
    this.showSpinner[index] = true;
    const column: any = _.find(this.columns, ['researched', true]);
    const requestData: any = {
      'app_id': _.get(this.activeResearchRow, 'assignment_values.app_id'),
      'remove_columns': []
    };
    _.each(this.columns, (_column: any) => {
      // remove invalid columns and researched column values
      if (_.get(this.activeResearchRow, `highlightedColumns.${[_column.col]}`) || _column.researched) {
        requestData.remove_columns.push(_.get(_column, 'columnName'));
      }
    });
    this.fitmentsService.replaceAppMultipleColumns(
      this.brandId,
      this.productId,
      requestData,
    ).subscribe((data: any) => {
      this.researchSaved.emit();
      this.emitRevisionId(_.get(data, 'item_detail_revision_id'));
    });
  }

  private getRowMaxWidth(): number {
    return _.reduce(this.columns, (prev: number, next: any) => {
      if (next.maxWidth) { return prev + next.maxWidth; }
      return prev;
    }, 0);
  }

  private subscribeWindowResize(): void {
    fromEvent(window, 'resize')
    .pipe(debounceTime(300),
    takeWhile(() => this.isActive))
    .subscribe((e: any) => {
      this.setContainerWidth();
    });
  }

  private setContainerWidth() {
    this.setVisibleWidth();
    const rowMaxWidth = this.getRowMaxWidth();
    // const visibleContentSize = document.body.offsetWidth - sideDrawerMenuWidth;
    // if (visibleContentSize >= rowMaxWidth) {
    if (this.visibleWidth >= rowMaxWidth) {
      this.containerWidth = null;
    } else {
      this.containerWidth = rowMaxWidth;
    }
    this.ref.markForCheck();
  }

  private setVisibleWidth() {
    // this.visibleWidth = document.body.offsetWidth - sideDrawerMenuWidth - (searchResultsOffset * 2);
    this.visibleWidth = this.searchResultsWrapWidth - (this.searchResultsOffset * 2);
  }

  private cancelAllResearchData(): void {
    this.showSpinner = {};
    this.activeResearchRow = null;
    this.activeRowIndex = null;
    this.activeResearchColumn = null;
    this.clearResearch();
  }

  private clearResearch() {
    this.researchRows = [];
    this.selectedResearchRows = [];
    this.researchColumns = [];
    this.checkedCopyInfo = true;
    this.showCopyInfoNote = false;
    this.researchModel = new ResearchModel();
  }

  private subscribeDuplicateModal(): void {
    this.appModalService.activeModal.confirm
    .pipe(first(), takeWhile(() => !!this.appModalService.activeModal))
    .subscribe(() => {
      this.checkedCopyInfo = true;
      this.ref.markForCheck();
    });
    this.appModalService.activeModal.cancel
    .pipe(first(), takeWhile(() => !!this.appModalService.activeModal))
    .subscribe(() => {
      this.checkedCopyInfo = false;
      this.ref.markForCheck();
    });
  }

  /*
    * Note: may have side effects
    * if user clicks on the same column twice it should be closed,
    * if user clicks on specific fields like mfr label, position, notes,
    * then we should open fitment edit panel
    * if base vehicle is invalid then open add fitment modal
  */
  private isResearchAllowed(row: any, column: any, index: number): boolean {
    if (this.disableResearch) { return false; }
    if (this.activeResearchRow || this.activeEditRow) {
      // Prevent clicking on non active row while researching
      if (this.activeRowIndex !== index) { return false; }
      // Close researching if user clicks again on the same cell
      if (column.columnName === this.researchColumnName) {
        this.cancelAllResearchData();
        return false;
      }
    }
    // don't allow research by editable fields
    if (this.isEditableField(column.columnName)) {
      return false;
    }
    // do not allow research if year/make/model/submodel(optionaly) are invalid
    if (row.invalidBaseVehicle) {
      this.baseVehicleResearch.emit(row);
      return false;
    } else {
      // dont allow research by YMM
      if (this.isBaseVehicleColumn(column)) {
        return false;
      }
    }
    return true;
  }

  private runResearch(row: any, column: any, index: number): void {
    this.showSpinner[index] = true;
    this.searchService.runResearch(
      this.brandId,
      this.getResearchQueryStirng(row, column),
    ).subscribe((data: any) => {
      // do not pre check results if fitment is invalid
      if (row.status === 0) {
        const currentItem = _.find(data.data, (item: any) => {
          return String(item.assignment_values.base_vehicle_id) === String(row.assignment_values.base_vehicle_id) &&
            String(item[column.col]) === String(row[column.col]);
        });
        if (currentItem) {
          currentItem.selected = true;
          // prevent uncheck vehicle type SPD2-2379
          if (_.get(column , 'attribute_name') === 'vehicleType') {
            currentItem.uncheckable = true;
          } else {
            currentItem.assigned = true;
          }
          this.selectedResearchRows.push(currentItem);
        }
      }
      this.setData(row, column, index, data);
      this.showSpinner[index] = false;
    });
  }

  private tooltipTemplate(title: string, text: string): string {
    return `
      <div class='tooltip-black-title'>${title}</div>
      <p class='tooltip-black-text'>${text}</p>`;
  }

  private isBaseVehicleColumn(column: any): boolean {
    return _.includes(['year', 'make', 'model'], column.col);
  }

  private isEditAllowed(row: any, column: any, index: number): boolean {
    // Prevent clicking on
    // non active row while editing
    if ((this.activeEditRow || this.activeResearchRow) && this.activeRowIndex !== index) { return false; }
    // when edit is disabled or field is not editable
    if (!this.isNestedTableEditableField(column.columnName)) {
      return false;
    }
    return true;
  }

  /*
    * Set column, row, index, that will be edited
    * Shows nested form
   */
  private showNestedTableEditForm(row: any, column: any, index: number) {
    this.activeEditColumn = column;
    this.activeEditRow = row;
    this.activeRowIndex = index;
    this.ref.markForCheck();
  }

  private clearEdit(): void {
    this.activeEditRow = null;
    this.activeRowIndex = null;
    this.activeEditColumn = null;
  }

  /*
    * Check if field can be edited in the cell or in the nested table form
   */
  private isEditableField(columnName: string): boolean {
    return this.isEditableInCellField(columnName) ||
           this.isNestedTableEditableField(columnName);
  }

  /*
    * Check if the field can be edited in the cell via input/select
   */
  private isEditableInCellField(columnName: string): boolean {
    return _.has(editableInCellColumns, columnName);
  }

  /*
    * Check if the field can be edited in the nested table form
   */
  private isNestedTableEditableField(columnName: string): boolean {
    return _.has(nestedTableEditableColumns, columnName);
  }

  /*
    * Creates form group for all controls in the cells
    * Structure:
    * {
    *   '0': {'qty': FormControl, 'position': FormControl },
    *   '1': {'qty': FormControl, 'position': FormControl }
    * }
   */
  private createCellControlsForm(): void {
    const controlsGroup: any = _.reduce(this.rows, (result: any, row: any, index: number) => {
      result[index] = this.fb.group(
        _.reduce(editableInCellColumns, (controls: any, item: any, columnName: string) => {
          controls[item.fieldMap] = new UntypedFormControl(_.get(row, item.itemName));
          return controls;
        }, {})
      );
      return result;
    }, {});
    this.cellControlsForm = this.fb.group(controlsGroup);
    this.ref.markForCheck();
  }

  private getColumnControlProp(columnName: string, property: string): any {
    return _.get(editableInCellColumns, `${columnName}.${property}`);
  }

  /*
    * Updates row data after save
    * Updates row's app id after save (it's being changed after every save)
   */
  private updateEditedRowAfterSave(appId: string|number, row: any, column: any, assignmentValue: any, cellValue: any): void {
    _.set(row, 'assignment_values.app_id', appId);
    _.set(row, this.searchService.idField, appId);
    let pathToAssignmentValue: string;
    if (this.isEditableInCellField(column.columnName)) {
      pathToAssignmentValue = this.getColumnControlProp(column.columnName, 'itemName');
    } else {
      pathToAssignmentValue = _.get(nestedTableEditableColumns, `${column.columnName}.itemName`);
    }
    _.set(row, pathToAssignmentValue, assignmentValue);
    _.set(row, column.col, cellValue);
    this.ref.markForCheck();
  }

  private isComingSoonColumn(columnName: string): boolean {
    return _.includes(this.comingSoonColumns, columnName);
  }

  private emitRevisionId(revisionId: string|number) {
    this.revisionIdChanged.emit(revisionId);
  }
}
